/* global $:true */
import debug from "debug";

import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-toggle-on-dirty]';
const PLUGIN_NAME = 'toggleOnDirty';
const MODULE_NAME = 'app.core/modules/updateable-textarea-component';
const log = debug(MODULE_NAME);


log('registerd');

class ToggleOnDirty {

  constructor(element, options) {
      log('new instance', element, options);

      this.element = element;
      this.options = options;

      this.$element = $(element);
      this.value = this.$element.val();
      this.initial = this.value;

      this.$element.on('keyup', this.change.bind(this));
      this.$element.on('change', this.change.bind(this));

      this.toggles = $(options.toggleSelectors);
      this.toggles.addClass('JS__toggle-on-dirty--target');

      log('ready', this.$element);

      this.change();
  }

  change () {
    this.value = this.$element.val();
    log('change', this.$element, this.value, this.initial);

    if (this.isDirty) {
        this.toggles
            .removeClass(this.options.toggleClassnames);
    } else {
        this.toggles
            .addClass(this.options.toggleClassnames);
    }
  }

  get isDirty () {
    const yesno = this.initial !== this.value;
    log('isDirty', this.$element, yesno);

    return yesno;
  }

}

ToggleOnDirty.DEFAULTS = {
  toggleSelectors: '',
  toggleClassnames: 'JS__toggle-on-dirty--is-clean',
};

plugin(PLUGIN_NAME, ToggleOnDirty);

export function exec () {
  $(document).ready(() => {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./client/src/core/modules/toggle-on-dirty/index.js